import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../../components/sidebar/Sidebar";
import LoadingSpinner from "../../../components/LoadingSpinner";
import "../../accounts/view/ViewAccountPage.css";
import { Username } from "../../../utils/privacyMask";

function InfoItem({ icon, label, value }) {
  return (
    <div className="info-item">
      <div className="info-label"><i className={`bi ${icon}`} />{label}</div>
      <div className={`info-value ${!value ? 'muted' : ''}`}>{value || 'Not provided'}</div>
    </div>
  );
}

export default function ViewReferralPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [referral, setReferral] = useState(null);
  const [referer, setReferer]   = useState(null);
  const [refered, setRefered]   = useState(null);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
        const refRes = await axios.get(`${process.env.REACT_APP_API_URL}/referral/${id}`, { headers });
        setReferral(refRes.data);
        const [rr, rd] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/account/${refRes.data.referer}`, { headers }),
          axios.get(`${process.env.REACT_APP_API_URL}/account/${refRes.data.refered}`, { headers }),
        ]);
        setReferer(rr.data);
        setRefered(rd.data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load referral");
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <LoadingSpinner />;
  if (error || !referral) return (
    <div className="view-page">
      <div className="view-panel">
        <div style={{ padding: 24, color: '#f87171' }}>
          <i className="bi bi-exclamation-triangle-fill me-2" />{error || 'Referral not found'}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Sidebar title="View Referral" />

      <div className="view-page">

        {/* ── Header ── */}
        <div className="view-header">
          <div className="view-header-left">
            <div className="view-avatar" style={{ background: 'linear-gradient(135deg, #a78bfa, #7c3aed)' }}>
              <i className="bi bi-share-fill" />
            </div>
            <div>
              <div className="view-title">Referral Details</div>
              <div className="view-subtitle">ID: {referral._id}</div>
            </div>
          </div>
          <Link to={`/referral/edit/${referral._id}`} className="btn-edit-account">
            <i className="bi bi-pencil-square" /> Edit Referral
          </Link>
        </div>

        {/* ── Stat cards ── */}
        <div className="view-stats" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
          <div className="view-stat-card" style={{ '--accent': '#3b82f6', '--glow': 'rgba(59,130,246,0.3)' }}>
            <div className="view-stat-label">Referer</div>
            <div className="view-stat-value" style={{ fontSize: '1.1rem' }}>{referer?.account?.username ? <Username value={referer.account.username} /> : '—'}</div>
            <i className="bi bi-person-fill view-stat-icon" />
          </div>
          <div className="view-stat-card" style={{ '--accent': '#a78bfa', '--glow': 'rgba(167,139,250,0.3)' }}>
            <div className="view-stat-label">Referred</div>
            <div className="view-stat-value" style={{ fontSize: '1.1rem' }}>{refered?.account?.username ? <Username value={refered.account.username} /> : '—'}</div>
            <i className="bi bi-person-check-fill view-stat-icon" />
          </div>
          <div className="view-stat-card" style={{ '--accent': '#06b6d4', '--glow': 'rgba(6,182,212,0.3)' }}>
            <div className="view-stat-label">Referral Date</div>
            <div className="view-stat-value" style={{ fontSize: '1.1rem' }}>{new Date(Number(referral.referDate)).toLocaleDateString()}</div>
            <i className="bi bi-calendar-event view-stat-icon" />
          </div>
        </div>

        {/* ── Referral info ── */}
        <div className="view-panel">
          <div className="view-panel-header">
            <h6 className="view-panel-title">
              <i className="bi bi-share-fill" style={{ color: '#a78bfa' }} />
              Referral Information
            </h6>
          </div>
          <div className="info-grid">
            <InfoItem icon="bi-person-fill"       label="Referer"       value={referer?.account?.username ? <Username value={referer.account.username} /> : null} />
            <InfoItem icon="bi-person-check-fill" label="Referred"      value={refered?.account?.username ? <Username value={refered.account.username} /> : null} />
            <InfoItem icon="bi-calendar-event"    label="Date"          value={new Date(Number(referral.referDate)).toLocaleDateString()} />
            <InfoItem icon="bi-journal-text"      label="Notes"         value={referral.notes} />
          </div>
        </div>

        {/* ── Actions ── */}
        <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
          <button className="btn-edit-account" onClick={() => window.history.back()}>
            <i className="bi bi-arrow-left" /> Back
          </button>
          {referer && (
            <button className="btn-edit-account" onClick={() => navigate(`/account/view/${referer.account._id}`)}>
              <i className="bi bi-person-fill" /> View Referer
            </button>
          )}
          {refered && (
            <button className="btn-edit-account" onClick={() => navigate(`/account/view/${refered.account._id}`)}>
              <i className="bi bi-person-check-fill" /> View Referred
            </button>
          )}
        </div>

      </div>
    </>
  );
}
